import { TAffairKind } from "@api/affair.int";
import { TGuardKind } from "@api/auth.int";
import { Box, BoxProps, HeadingProps, IconProps, useToken } from "@chakra-ui/react";
import { MyIconCsotores, MyIconDugulas, MyIconEloviz, MyIconKozkut, MyIconVizminoseg } from "components/icons";
import { useVVStore } from "./store";

export const AFFAIR_KINDS: {
    [key in TAffairKind]: {
        name: string,
        name2: string,
        color: string,
        icon: (props: IconProps) => JSX.Element,
    }
} = {
    'vizminoseg': { color: '#197ea7', icon: MyIconVizminoseg, name: 'Vízminőség probléma', name2: 'Vízminőség problémát' },
    'csotores': { color: '#b34d9d', icon: MyIconCsotores, name: 'Csőtörés', name2: 'Csőtörést' }, //#a84db3 // orig: #bd5459
    'kozkut': { color: '#8663ce', icon: MyIconKozkut, name: 'Közkút meghibásodás', name2: 'Közkút meghibásodást' },
    'dugulas': { color: '#73af4e', icon: MyIconDugulas, name: 'Dugulás', name2: 'Dugulást' },
    'eloviz': { color: '#00a775', icon: MyIconEloviz, name: 'Élővíz szennyezés', name2: 'Élővíz szennyezést' },
}
// --chakra-colors-chakra-body-bg: #0b273f
// secondary-main: #5dc0a1
export const AFFAIR_KINDS_ARR = Object.entries(AFFAIR_KINDS).map(([k, o]) => ({ ...o, key: k as TAffairKind }));

export const GUARD_KINDS: {
    [key in TGuardKind]: {
        name: string,
        src: string,
    }
} = {
    '00': { name: 'Felhasználó', src: '/icons/guard_user.svg' },
    '10': { name: 'Vízibolha', src: '/icons/guard_vizibolha.svg' },
    '20': { name: 'Vízőr', src: '/icons/guard_vizor.svg' },
    '25': { name: 'Vizedes', src: '/icons/guard_vizedes.svg' },
    '30': { name: 'Vízőrmester', src: '/icons/guard_vizormester.svg' },
}
export const GUARD_KINDS_ARR = Object.entries(GUARD_KINDS).map(([k, o]) => ({ ...o, key: k as TGuardKind })).sort((a, b) => parseInt(a.key) - parseInt(b.key));


export const HEADER_TITLE_HEIGHT = 64;
export const NEW_LOCATION_ZOOM = 16;
export const NEW_LOCATION_IN_CITY_ZOOM = 13;

export const BOX_TRAN = '.25s ease-out';

export function useVVColors() {
    const [primary] = useToken('colors', ['primary.main']);
    const bg = 'var(--chakra-colors-cardbg-main)';
    return {
        borderColor: primary, primary, bg
    }

}






export interface VVCardContainerProps extends BoxProps {
}
export function VVCardContainer({ ...rest }: VVCardContainerProps) {
    return <Box
        className="vv-card-container"
        border='1px solid red'


        display='flex' flexDir='column' overflow='hidden'
        alignItems='stretch' justifyContent='flex-start'
        gap={2} p={3}

        {...rest}
    />
}


// ------------------------------------------------------ BOGYOPROPS --------------------------------
export interface BogyoProps extends BoxProps {
    kind: TAffairKind;
}


export function Bogyo({ kind, ...rest }: BogyoProps) {
    let Img = AFFAIR_KINDS[kind].icon;
    return <Box
        borderRadius='50%'
        bg={AFFAIR_KINDS[kind].color}
        width='48px' height='48px'
        display='flex' alignItems='center' justifyContent='center'
        {...rest}

    ><Img color='#fff' width='36px' />
    </Box>
}

export function Bogyo2({ kind, ...rest }: BogyoProps) {
    let Img = AFFAIR_KINDS[kind].icon;
    return <Img
        //color={AFFAIR_KINDS[kind].color}
        color='#0008'
        width='27px' mr={2}
    />

}


